import React, { useState } from "react";
import logger from "@/utils/logger";
interface FilterItemProps {
  icon: string;
  name: string;
  selectedFilter: string | null;
  setSelectedFilter: (filter: string | null) => void;
  toggleDropdown?: () => void;
}

const FilterItem: React.FC<FilterItemProps> = ({
  icon,
  name,
  selectedFilter,
  setSelectedFilter,
  toggleDropdown,
}) => {
  // State to manage hover
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  const handleClick = () => {
    if (selectedFilter === name) {
      logger.log("Clear filter");
      setSelectedFilter(null); // Clear filter
      if (toggleDropdown) {
        toggleDropdown();
      }
    } else {
      setSelectedFilter(name); // Set new filter
    }
  };

  return (
    <button
      className={`flex items-center justify-between px-4 py-2 rounded-md cursor-pointer duration-300 transition-all ease-in-out ${
        selectedFilter === name
          ? "bg-indigo-800 text-white"
          : "bg-white text-neutral-700 hover:bg-neutral-100 hover:text-neutral-800"
      }`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      {isHovered && selectedFilter === name ? (
        <div className="flex flex-row items-center justify-center space-x-2 w-full">
          <p className="text-[13px]">Clear</p>
          <i className="fa-regular fa-circle-xmark text-white text-[15px]"></i>{" "}
        </div>
      ) : (
        <span className="flex items-center">
          <i className={`${icon} mr-3 text-[14px]`}></i>
          <span className="text-[13px]">{name}</span>
        </span>
      )}
    </button>
  );
};

const experiencesFilterItems = [
  { icon: "fas fa-camera-retro", name: "Attractions" },
  { icon: "fas fa-tree", name: "Parks" },
  { icon: "fas fa-music", name: "Music" },
  { icon: "fas fa-museum", name: "Museums" },
  { icon: "fas fa-football", name: "Sport" },
  { icon: "fas fa-theater-masks", name: "Theatre" },
  { icon: "fas fa-umbrella-beach", name: "Beaches" },
  { icon: "fas fa-monument", name: "Historical" },
  { icon: "fas fa-fish", name: "Aquariums" },
  { icon: "fas fa-ship", name: "Cruises" },
  { icon: "fas fa-church", name: "Worship" },
];

const activitiesFilterItems = [
  { icon: "fas fa-ticket-alt", name: "Tours" },
  { icon: "fas fa-hiking", name: "Adventure" },
  { icon: "fas fa-spa", name: "Relaxation" },
  { icon: "fas fa-biking", name: "Cycling" },
];

const foodDrinkFilterItems = [
  { icon: "fas fa-utensils", name: "Restaurants" },
  { icon: "fas fa-cocktail", name: "Nightlife" },
  { icon: "fas fa-glass-cheers", name: "Bars" },
  { icon: "fas fa-utensils", name: "Cheap Eats" },
  { icon: "fas fa-money-bill-wave", name: "Fine Dining" },
  { icon: "fas fa-utensils", name: "Street Food" },
  { icon: "fas fa-shopping-bag", name: "Markets" },
  { icon: "fas fa-coffee", name: "Cafes" },
  { icon: "fas fa-ice-cream", name: "Desserts" },
  { icon: "fas fa-wine-glass-alt", name: "Wine Tasting" },
  { icon: "fas fa-beer", name: "Breweries" },
  { icon: "fas fa-pizza-slice", name: "Pizza" },
];

export {
  FilterItem,
  experiencesFilterItems,
  activitiesFilterItems,
  foodDrinkFilterItems,
};
